var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.bgWhite?'bg-white':''],style:({height:_vm.statusbarHeight+'px'})})
}
var staticRenderFns = []

export { render, staticRenderFns }